import { getOrders } from '$lib/customer/getOrders';


import type { GetCustomerOrdersQuery } from '$lib/types-customer/customer.generated';
export type Order = NonNullable<GetCustomerOrdersQuery['customer']>['orders']['edges'][0]['node'];
type NextCursor = NonNullable<GetCustomerOrdersQuery['customer']>['orders']['pageInfo']['endCursor'];
export let ordersStore = $state<{
    orders: Order[];
    loading: boolean;
    nextCursor: NextCursor;
}>({ orders: [], loading: false, nextCursor: undefined });

export async function loadFirst() {
  ordersStore.loading = true;
  let { orders, nextCursor } = await getOrders();
  ordersStore.orders = orders;
  ordersStore.nextCursor = nextCursor;
  ordersStore.loading = false;
}
       
export async function loadMore() {
  if (!ordersStore.nextCursor || ordersStore.loading) return;
  ordersStore.loading = true;
  const { orders, nextCursor } = await getOrders(20, ordersStore.nextCursor);
  ordersStore.orders.push(...orders);
  ordersStore.nextCursor = nextCursor;
  ordersStore.loading = false;
}
